module.exports = __webpack_public_path__ + "static/media/report.7f18fc59.svg";